
import { TechGrid, GlassCard } from '../../../components/base/FuturisticElements';

export function ContactHeroSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <TechGrid />
      
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-light mb-6 tracking-tight text-white">
            Get in Touch
          </h1>
          <p className="text-xl mb-8 leading-relaxed font-light text-gray-400">
            Interested in joining our beta program for next-generation cybersecurity protection? 
            Our Manchester-based development team would love to hear from you.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            <GlassCard className="text-center">
              <div className="w-12 h-12 bg-blue-500/200/20 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-blue-400 text-xl"></i>
              </div>
              <h3 className="font-medium mb-2 text-white">Quick Response</h3>
              <p className="text-gray-400">We respond to all inquiries within 24 hours</p>
            </GlassCard>
            <GlassCard className="text-center">
              <div className="w-12 h-12 bg-blue-500/200/20 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-blue-400 text-xl"></i>
              </div>
              <h3 className="font-medium mb-2 text-white">Expert Support</h3>
              <p className="text-gray-400">Speak directly with our cybersecurity experts</p>
            </GlassCard>
            <GlassCard className="text-center">
              <div className="w-12 h-12 bg-blue-500/200/20 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-blue-400 text-xl"></i>
              </div>
              <h3 className="font-medium mb-2 text-white">UK Based</h3>
              <p className="text-gray-400">Local support from our Manchester office</p>
            </GlassCard>
          </div>
        </div>
      </div>
    </section>
  );
}
